import classNames from 'classnames';
import { tuple } from './type';
const InputStatuses = tuple('warning', 'error', '');
export function getStatusClassNames(prefixCls, status, hasFeedback) {
    return classNames({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback,
    });
}
export const getMergedStatus = (contextStatus, customStatus) => customStatus || contextStatus;
